/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExportedTaskInputRubricAnyOf } from './exportedTaskInputRubricAnyOf';

export type ExportedTaskInputRubric = ExportedTaskInputRubricAnyOf | null;
